import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.subCategoryNameLinkItem = {
    width: [10, 10, 12, 12, 12],
    css: css`
        padding-bottom: 8px;
        span {
            color: #2e64b0 !important;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    justify-content: center;
                `,
                css`
                    justify-content: center;
                `,
                css`
                    justify-content: center;
                `,
            ])}
    `,
};
categoryDetailSubCategoriesStyles.subCategoryImage = {
    css: css`
        img {
            height: 150px;
            width: 150px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            height: 50px;
                            width: 100%;
                        `,
                        css`
                            height: 50px;
                            width: 100%;
                        `,
                        null,
                        null,
                    ],
                    "minMax",
                );
            }}
        }
    `,
};
categoryDetailSubCategoriesStyles.container = {
    gap: 0,
    css: css`
        padding-left: 50px;
    `,
};
